import React, { Component } from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useStore } from '@vromo/mobx-react';

const Container = styled.div`
    background: ${({ theme }) => theme.header || theme.background};
    height: 60px;
    flex-basis: 60px;
    text-align: center;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export default observer(function Branding() {
    const rootStore = useStore('rootStore');

    const job = rootStore.jobs.first();

    if (!job) return null;

    if (job.campaign.logo.url) {
        return (
            <Container>
                <img src={job.campaign.logo.url} style={{ height: 50, width: 'auto' }} />
            </Container>
        );
    } else {
        return null;
    }
});
